export default __webpack_public_path__ + "static/media/ISEO_CLASS-4_SYLLABUS_2025-26.576ba15b.pdf";